import { z } from 'zod';
import { legalEntitySchema } from './legal.schema';
import { nameSchema, objectIdSchema } from '../validation';
import { bankCommonInfoSchema } from './bank.schema';
import { imageWithUploadSchema } from './image.schema';
import { businessSettingsSchema } from '../model/business/business.settings.modal'; // this avoids any errors in circular dependencies
import { orgFinancingProfileSchema } from '../model/financing/financing.profile.model';

const bank = bankCommonInfoSchema.shape;

export const organizationProfileSchema = legalEntitySchema.extend({
  /** the id of the organization */
  _id: objectIdSchema,
  /** the display name of the organization such as Hero App*/
  displayName: nameSchema,
  /**
   * Org logo. Surfaced on the flat profile projection so the FE
   * General tab (and any other surface that hydrates from
   * `OrganizationProfile`) can render the existing logo without
   * an extra fetch. Matches `Org.logo` on the underlying model.
   */
  logo: imageWithUploadSchema.optional(),
  /** the name of the bank such as Al Rajhi */
  bankName: bank.bankName,
  /** the IBAN number of the bank account such as SA12323 */
  bankIBAN: bank.IBAN,
  /** the name on the bank account such as ALTREG ALRAQMI LLC */
  bankAccountName: bank.accountName,
  /** a proof of the image */
  bankAccountImage: bank.accountImage,
  businessSettings: businessSettingsSchema.optional(),
  /**
   * Org-level financing profile (fleet tier, revenue tier, financing
   * needs, ownership, financials, optional uploaded statements).
   * Present on the flat profile projection so the carrier dashboard's
   * Organization → Financing tab and the financing apply wizard can
   * pre-fill from a single `GET /org/profile` round-trip — no
   * separate `/financing/profile` endpoint.
   */
  financingProfile: orgFinancingProfileSchema.optional(),
});
export type OrganizationProfile = z.infer<typeof organizationProfileSchema>;
